document.addEventListener('DOMContentLoaded', (event) => {
    var ctlbSwipes = new Swiper('.ctlb .ctlb__items.swiper-container', {
        loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        // autoplay: {
        //     delay: 1000,
        // },
        breakpoints: {
            819: {
                centeredSlides: true,
            },
            1279: {
                centeredSlides: false,
            },
            3000: {
                centeredSlides: false,
                autoplay: false
            }
        }
    });
});